/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: RU (Russian; русский язык)
 */
$.extend($.validator.messages, {
    // default
    required: 'Это поле необходимо заполнить.',
    remote: 'Пожалуйста, введите правильное значение.',
    email: 'Пожалуйста, введите корректный адрес электронной почты.',
    url: 'Пожалуйста, введите корректный URL.',
    date: 'Пожалуйста, введите корректную дату.',
    dateISO: 'Пожалуйста, введите корректную дату в формате ISO.',
    number: 'Пожалуйста, введите число.',
    digits: 'Пожалуйста, вводите только цифры.',
    creditcard: 'Пожалуйста, введите правильный номер кредитной карты.',
    equalTo: 'Пожалуйста, введите такое же значение ещё раз.',
    extension: 'Пожалуйста, выберите файл с правильным расширением.',
    maxlength: $.validator.format('Пожалуйста, введите не больше {0} символов.'),
    minlength: $.validator.format('Пожалуйста, введите не меньше {0} символов.'),
    rangelength: $.validator.format('Пожалуйста, введите значение длиной от {0} до {1} символов.'),
    range: $.validator.format('Пожалуйста, введите число от {0} до {1}.'),
    max: $.validator.format('Пожалуйста, введите число, меньшее или равное {0}.'),
    min: $.validator.format('Пожалуйста, введите число, большее или равное {0}.'),
    // custom
    callback_phone: {
        required: 'Не указан телефон',
        phoneMask: 'Указан неверный телефон'
    },
    callback_approval: {
        required: 'Необходимо подтвердить что вы ознакомлены и согласны'
    },
    feedback_phone: {
        required: 'Не указан телефон',
        phoneMask: 'Указан неверный телефон'
    },
    feedback_name: {
        required: 'Не указано имя'
    },
    feedback_city: {
        required: 'Не указан город'
    },
    account_password: {
        required: 'Не введен старый пароль'
    },
    account_password_new: {
        required: 'Не введен новый пароль',
        minlength: 'Длина пароля не менее 6 символов'
    },
    account_password_repeat: {
        required: 'Не введен повтор нового пароля',
        minlength: 'Длина пароля не менее 6 символов',
        equalTo: 'Введенные пароли не совпадают'
    },
    NAME: {
        required: 'Не указано имя'
    },
    LAST_NAME: {
        required: 'Не указана фамилия'
    },
    EMAIL: {
        required: 'Не указан адрес электронной почты',
        email: 'Указан неверный e-mail',
        remote: 'Пользователь с таким email является оптовым покупателем (покупка в один клик недоступна)'
    },
    UF_PHONE: {
        required: 'Не указан телефон',
        phoneMask: 'Указан неверный телефон'
    },
    PHONE: {
        required: 'Не указан телефон',
        phoneMask: 'Указан неверный телефон'
    },
    UF_SALONPHONE: {
        phoneMask: 'Указан неверный телефон'
    },
    WORK_CITY: {
        required: 'Не указан город'
    },
    PERSONAL_CITY: {
        required: 'Не указан город'
    },
    UF_SALONNAME: {
        required: 'Не указано название салона'
    },
    UF_ADRES: {
        required: 'Не указан адрес салона'
    },
    UF_KPP: {
        KPP_RUS: 'Введен неверный КПП'
    },
    UF_INN: {
        all_req: 'Не указан ИНН',
        INN_RUS: 'Введен неверный ИНН'
    },
    UF_COMPANY: {
        all_req: 'Не указано наименвание организации (ИП)'
    },
    UF_UADRESS: {
        all_req: 'Не указан юридический адрес'
    },
    UF_POST: {
        required: 'Не указана должность'
    },
    UF_BUSINESS_PROFILE: {
        required: 'Не указана сфера деятельности'
    },
    cart_promocode: {
        required: 'Не указан промо-код'
    },
    cart_agree: {
        required: 'Согласие c условиями доставки и оплаты обязательно'
    },
    cabinet_address: {
        emptyLocaton: 'Не заполнено поле Город',
        emptyStreet: 'Не заполнено поле Улица',
        wrongHouseNumber: 'Неверный формат номера дома'
    }
});



// WEBPACK FOOTER //
// ./localization/messages_ru.js